import _isNil from 'lodash/isNil';
import React from 'react';
import Zoomist from 'zoomist';
import MainImageSkeleton from './Skeletons/MainImageSkeleton';

interface IMainImgProps {
    id: string;
    containerHeight: any;
    loadedUrl: string;
}

interface IMainImgState {
    img: string | null;
    zoomist: any;
}

class EntityMainImage extends React.Component<IMainImgProps, IMainImgState> {
    private zoomistContainerRef: React.RefObject<HTMLDivElement>;

    constructor(props) {
        super(props);
        this.state = {
            img: null,
            zoomist: null,
        };
        this.reset = this.reset.bind(this);
        this.zoomIn = this.zoomIn.bind(this);
        this.zoomOut = this.zoomOut.bind(this);
        this.resetZoom = this.resetZoom.bind(this);
        this.zoomistContainerRef = React.createRef<HTMLDivElement>();
    }

    componentDidMount() {
        this.setState({ img: this.props.loadedUrl });
    }

    componentDidUpdate(prevProps: Readonly<IMainImgProps>) {
        if (
            prevProps.loadedUrl !== this.props.loadedUrl &&
            this.props.loadedUrl
        ) {
            this.setState({ img: this.props.loadedUrl });
        }
    }

    reset() {
        this.setState({
            img: null,
            zoomist: null,
        });
    }

    zoomIn() {
        this.state.zoomist.zoom(0.1);
    }

    zoomOut() {
        this.state.zoomist.zoom(-0.1);
    }

    resetZoom() {
        this.state.zoomist.reset();
    }

    getImageData() {
        this.state.zoomist.getImageData();
    }

    render() {
        if (!this.state.zoomist) {
            setTimeout(() => {
                const zoomistContainer = this.zoomistContainerRef.current;
                if (this.state.img && zoomistContainer) {
                    const zoomistDom = new Zoomist(zoomistContainer, {
                        bounds: true,
                        fill: 'contain',
                        height: '100%',
                        on: {
                            ready() {
                                this.setState({ zoomist: zoomistDom });
                            },
                        },
                    });
                }
            }, 1500);
        }

        return _isNil(this.state.img) ? (
            <MainImageSkeleton containerHeight={this.props.containerHeight} />
        ) : (
            <div
                ref={this.zoomistContainerRef}
                id={`zoomistContainer${this.props.id}`}
                data-zoomist-src={this.state.img}
            ></div>
        );
    }
}
export default EntityMainImage;
